export const FIND_INDICATOR_IDS_FAILURE = 'FIND_INDICATOR_IDS_FAILURE';

export const findIndicatorIdsFailure = ({ error, request }) => ({
    type: FIND_INDICATOR_IDS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});